import { render, staticRenderFns } from "./AdminQueue.vue?vue&type=template&id=1eb7fa8d"
import script from "./AdminQueue.vue?vue&type=script&lang=js"
export * from "./AdminQueue.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports